import { useEffect, useState } from "react";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

function InfoCard({ title, children }) {
  return (
    <div className="rounded-2xl border border-[#1f2937] bg-[#121826] p-5">
      <p className="text-xs uppercase tracking-wide text-slate-400 mb-2">
        {title}
      </p>
      <div className="text-slate-100">{children}</div>
    </div>
  );
}

export default function DashboardCliente() {
  const [data, setData] = useState({
    tem_prazo: false,
    prazo: null,
    ultima_movimentacao: null
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/cliente_dashboard.php")
      .then(res => setData(res.data))
      .catch(() => {
        setData({
          tem_prazo: false,
          prazo: null,
          ultima_movimentacao: null
        });
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <AppLayout title="Área do Cliente">
        <p className="text-slate-400">Carregando informações…</p>
      </AppLayout>
    );
  }

  return (
    <AppLayout
      title="Área do Cliente"
      subtitle="Acompanhe seu processo de forma simples"
    >

      {/* RESUMO */}
      <div className="mb-6 rounded-xl bg-blue-600/10 border border-blue-600/20 p-4">
        <p className="text-slate-100 font-medium">
          {data.tem_prazo
            ? "Há uma data importante em andamento."
            : "No momento, não há ações urgentes."}
        </p>
        <p className="text-sm text-slate-300 mt-1">
          Qualquer novidade relevante será informada por aqui.
        </p>

        {/* 👇 RESUMO AUTOMÁTICO DO PROCESSO */}
  {data.resumo && (
    <p className="text-sm text-slate-300 mt-2">
      {data.resumo}
    </p>
  )}
      </div>

      {/* CARDS */}
      <div className="grid gap-4 md:grid-cols-2">

        <InfoCard title="Próxima data importante">
          {data.prazo ? (
            <>
              <p className="font-medium">{data.prazo.descricao}</p>
              <p className="text-sm text-slate-400 mt-1">
                Data: {data.prazo.data_prazo}
              </p>
            </>
          ) : (
            <p className="text-sm text-slate-400">
              Nenhuma data pendente no momento.
            </p>
          )}
        </InfoCard>

        <InfoCard title="Última atualização">
          {data.ultima_movimentacao ? (
            <>
              <p className="font-medium">
                {data.ultima_movimentacao.descricao}
              </p>
              <p className="text-sm text-slate-400 mt-1">
                Em {data.ultima_movimentacao.criado_em}
              </p>
            </>
          ) : (
            <p className="text-sm text-slate-400">
              Ainda não há atualizações registradas.
            </p>
          )}
        </InfoCard>
      </div>

      {/* MENSAGEM FINAL */}
      <div className="mt-8 text-sm text-slate-400">
        Este painel mostra apenas informações essenciais.  
        Caso surja algo que exija sua atenção, você será avisado.
      </div>

    </AppLayout>
  );
}
